
import { Component, Prop, Vue } from 'vue-property-decorator';
import VTable from '@/components/shared/table/VTable.vue';
import headers from './headers';
import { Category } from '@/interfaces/models/Category';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import { Hours as AvailableHour } from '@/interfaces/models/Hours';
import { Permission } from '@/enums/Permission';
import adminHeaders from '@/components/category/adminHeaders';
import { hasPermission, toLocaleTime } from '@/util/helper';
import { WEEKDAYS } from '@/util/constant';

@Component({
  components: { VTable },
})
export default class CategoryTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: Category[];
  @Prop({ type: Number, required: true }) public total!: number;
  @Prop({ type: Number, default: () => 10 }) public limit!: number;

  public editDialog: any = {
    isVisible: false,
    value: null,
    name: '',
    original: null,
    cell: null,
  };

  get weekdays() {
    return WEEKDAYS(this.$i18n);
  }

  get itemsFiltered() {
    if (hasPermission(Permission.ARTICLE_VIEW_VISIBLE_ONLY, true)) {
      return this.items.filter((item: Category) => item.visible);
    }

    return this.items;
  }

  get headers() {
    if (this.$isAdmin()) {
      return adminHeaders;
    }

    return headers;
  }

  public availableHoursByWeekday(hour: AvailableHour): string {
    const openedAt = toLocaleTime(hour.openedAt) || hour.openedAt;
    const closedAt = toLocaleTime(hour.closedAt) || hour.closedAt;

    return `${this.weekdays[+hour.weekday]}: ${openedAt} - ${closedAt}`;
  }

  public edit(item: Category) {
    if (!this.canChangeCoupon(item)) {
      return;
    }
    this.$router.push({ name: 'category.edit', params: { id: item._id }, query: { ...this.$route.query } });
  }

  public editModal(data: { header: ColumnHeader; item: any }) {
    if (data.item) {
      this.editDialog.isVisible = true;
      this.editDialog.name = data.header.value;
      this.editDialog.original = { ...data.item };
      this.editDialog.value = this.getEditDialogValue(data.header.value, data.item);
      this.editDialog.cell = data.header.value;
    }
  }

  public getEditDialogValue(headerValue: string, item: any): any {
    const valueHandlers: { [key: string]: (value: any) => any } = {
      sortOrder: (value: string) => value || '',
    };
    const handler = valueHandlers[headerValue];

    return handler ? handler(item[headerValue]) : item[headerValue];
  }

  public canToggleVisbility(val: boolean) {
    if (val) {
      return this.$can(Permission.CATEGORY_VISIBLE);
    }
    return this.$can(Permission.CATEGORY_HIDE);
  }

  public canChangeCoupon(category: Category) {
    if (this.$isAdmin()) return true;
    if (category.name?.de === 'Coupons') {
      if (category.visible) {
        return this.$can(Permission.CATEGORY_COUPON_VISIBLE);
      }
      return this.$can(Permission.CATEGORY_COUPON_HIDE);
    }
    return true;
  }

  public saveCellValue() {
    const { name, value, original } = this.editDialog;

    const data = {
      original,
      field: name,
      value,
    };

    this.$emit('edited', data);
    this.stopEditing();
  }

  public stopEditing() {
    this.editDialog.isVisible = false;
    this.editDialog.value = null;
    this.editDialog.original = null;
    this.editDialog.name = '';
  }
}
